import React, {useState,useEffect} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import UpClient from "../../components/UpClient";
import GoBack from "../../components/goBack";
import ClientDetails from "./ClientDetails";
import useAuthHelper from "../../helpers/AuthHelper";

const SeeClientDetails = (props) => {
    const {onlyCommercial} =useAuthHelper();

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [displayEdit, setDisplayEdit] = useState('none');
    const location = useLocation();
    console.log(location.state?.client);

    useEffect(()=>{
        onlyCommercial();

    },[]);
    return (
        <>
            <div className="main-container container-fluid">
                <GoBack route='/clients/list'/>
                <ClientDetails type={props.clientType} client={location.state?.client}/>
            </div>
        </>
    );
}

export default SeeClientDetails;